import React, { useEffect } from 'react';

/**
 * Consistent modal overlay used throughout the app.
 * Closes on Escape key or backdrop click.
 *
 * Props:
 *   isOpen      - boolean
 *   onClose     - called when user dismisses
 *   children    - modal content
 *   width       - CSS width (default '520px')
 *   maxWidth    - CSS max-width (default 'calc(100vw - 32px)')
 */
export default function Modal({
  isOpen,
  onClose,
  children,
  width = '520px',
  maxWidth = 'calc(100vw - 32px)',
  cardClassName = '',
}) {
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="tp-modal-backdrop"
      onClick={onClose}
    >
      <div
        className={`tp-card tp-card--tight${cardClassName ? ` ${cardClassName}` : ''}`}
        style={{ width, maxWidth }}
        onClick={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
